import React, { useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import MusicBrowser from '../ui/MusicBrowser'
import FaIcon from '../../helpers/fa_icon'

const AddSongControls = ({ onChange, suggestionListId, disabled, position }) => {
  const [ showModal, setShowModal ] = useState(false)

  return (
    <div className="add-song-button-wrapper">
      <MusicBrowser
        onChange={song => onChange(song, position)}
        label={<FaIcon icon="plus" text="Add Song" />}
        title="Add Song"
        editExtendedAttributes={true}
        disabled={disabled}
      />
      { " " }
      <Button onClick={() => setShowModal(true)} variant="primary" disabled={disabled}>
        <FaIcon icon="upload" />
        { " " }
        Bulk Import
      </Button>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Import</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Check Cherry supports importing playlists from the following sources:</p>
          <div className="text-center">
            <a href={`/admin/suggestion_list_imports/new?suggestion_list_id=${suggestionListId}`} className="btn btn-outline-secondary">
              <FaIcon icon="upload" /> { " " } CSV File
            </a>
            { " " }
            <a href={`/admin/spotify_list_imports/new?suggestion_list_id=${suggestionListId}`} className="btn btn-outline-secondary">
              <FaIcon icon="spotify" /> { " " } Spotify Playlist
            </a>
            { " " }
            <a href={`/admin/apple_music_list_imports/new?suggestion_list_id=${suggestionListId}`} className="btn btn-outline-secondary">
              <FaIcon icon="apple" /> { " " } Apple Music Playlist
            </a>
            { " " }
            <a href={`/admin/youtube_music_list_imports/new?suggestion_list_id=${suggestionListId}`} className="btn btn-outline-secondary">
              <FaIcon icon="youtube" /> { " " } YouTube Playlist
            </a>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setShowModal(false)} variant="secondary">
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

export default AddSongControls
